module.exports = __webpack_public_path__ + "01_medium_gray.74ae5832.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_medium_gray.png
// module id = W+RP
// module chunks = 0